import React from 'react';
import { StickyNav } from './StickyNav';
import { HeroSection } from './HeroSection';
import { MechanismSection } from './MechanismSection';
import { ComparisonSection } from './ComparisonSection';
import { IncludesSection } from './IncludesSection';
import { AudienceSection } from './AudienceSection';
import { PricingSection } from './PricingSection';
import { Footer } from './Footer';
export function SalesPage() {
  return <main className="min-h-screen w-full bg-[#0F0F14] text-white selection:bg-[#E8636F] selection:text-white" data-id="element-224">
      <StickyNav data-id="element-225" />
      <HeroSection data-id="element-226" />
      <MechanismSection data-id="element-227" />
      <ComparisonSection data-id="element-228" />
      <IncludesSection data-id="element-229" />
      <AudienceSection data-id="element-230" />
      <PricingSection data-id="element-231" />
      <Footer data-id="element-232" />
    </main>;
}